import { useEffect } from 'preact/hooks'
import { useAthosContext } from 'libs/athos/fetchers/provider'
import { SearchPageLink } from 'libs/athos/components/quick-search/SearchPageLink'

/**
 *
 * @typedef defaultSuggestions
 * @type {suggestion[]}
 *
 * @typedef suggestion
 * @property {string} title
 * @property {string} url
 */

export function QuickSearchSuggestions({ query, defaultSuggestions }) {
  const { results, refine } = useAthosContext()

  useEffect(() => {
    if (query) {
      refine('query', query)
    }
  }, [query])

  if (results?.items?.length === 0 && !defaultSuggestions?.length > 0) return null

  // Create a combined array of suggestions to display, capped to 3 results
  const displaySuggestions = [...(results?.items || [])].slice(0, 3)

  // If we have default suggestions and fewer than 3 results, append default suggestions
  if (defaultSuggestions && displaySuggestions.length < 3) {
    // Only add enough default suggestions to reach a total of 3
    const suggestionsToAdd = defaultSuggestions.slice(0, 3 - displaySuggestions.length)

    // Add default suggestions to the display suggestions array
    displaySuggestions.push(...suggestionsToAdd)
  }

  return (
    <div className="flex flex-col gap-y-0.75 w-full">
      {displaySuggestions.map((suggestion, index) => {
        // Check if this is a search result or a default suggestion
        if (suggestion.query !== undefined) {
          // This is a search result item
          return (
            <SearchPageLink
              key={`result-${index}`}
              query={suggestion.query}
              className="group w-fit paragraph-s first-letter:capitalize link-fade"
            >
              <span>{suggestion.label}</span>
            </SearchPageLink>
          )
        } else {
          // This is a default suggestion
          return (
            <SearchPageLink
              key={`default-${index}`}
              url={suggestion.url}
              className="group w-fit paragraph-s first-letter:capitalize link-fade"
            >
              <span>{suggestion.title}</span>
            </SearchPageLink>
          )
        }
      })}
    </div>
  )
}
